import { atom } from 'jotai';

/**
 * 导航请求接口
 * 定义导航所需的参数
 */
export interface NavigationRequest {
  path: string;
  replace?: boolean;
}

/**
 * 导航请求atom
 * 存储当前的导航请求，初始值为null
 */
export const navigationRequestAtom = atom<NavigationRequest | null>(null);

/**
 * 导航action atom
 * 用于触发导航请求
 * 
 * 使用方法:
 * ```
 * set(navigateAtom, { path: '/v3/some-path', replace: true });
 * ```
 */
export const navigateAtom = atom(
  null,
  (_get, set, request: NavigationRequest) => {
    set(navigationRequestAtom, request);
  }
);
